export const ALL_FLOORS = 'ALL_FLOORS';

export function floorTargetFor(categoryFloors, currentFloor, categoryKey) {
  const known = categoryFloors[String(categoryKey)];

  if (known) {
    return known === currentFloor ? null : known;
  }

  return ALL_FLOORS;
}
